import React from "react";
import { Col, Row, Table } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import { ChartDoughnut, ChartLine, ChartStackedBar, FooterReport, Gap, GridInline, LabelTitle, Line, ProgressBar } from "../../../components/Global";
import PageEight from "./Component/PageEight";
import PageFive from "./Component/PageFive";
import PageFour from "./Component/PageFour";
import PageOne from "./Component/PageOne";
import PageSeven from "./Component/PageSeven";
import PageSix from "./Component/PageSix";
import PageThree from "./Component/PageThree";
import PageTwo from "./Component/PageTwo";

const Pemetaan = (props) => {
    const request = props.history.location.state.payload;

    require("./Pemetaan.css");
    return (
        <div>
            {/* Page One */}
            <PageOne
                idJadwalCbt={request.idJadwalCbt}
                idKelas={request.idKelas}
                kodeTahunAjaran={request.kodeTahunAjaran}
                kuotaPariwisata={request.kuotaPariwisata}
                kuotaBisnisDanManajemen={request.kuotaBisnisDanManajemen}
                kuotaSeniDanEkonomiKreatif={request.kuotaSeniDanEkonomiKreatif}
                kuotaAgribisnisDanAgriteknologi={request.kuotaAgribisnisDanAgriteknologi}
                kuotaKemaritiman={request.kuotaKemaritiman}
                kuotaKesehatanDanPekerjaanSosial={request.kuotaKesehatanDanPekerjaanSosial}
                kuotaTeknologiInformasi={request.kuotaTeknologiInformasi}
                kuotaTeknologiManufakturDanRekayasa={request.kuotaTeknologiManufakturDanRekayasa}
                kuotaTeknologiKonstruksiDanProperti={request.kuotaTeknologiKonstruksiDanProperti}
                kuotaEnergiDanPertambangan={request.kuotaEnergiDanPertambangan}
            />
            {/* Page One */}
            {/* Page Two */}
            {/* <PageTwo /> */}
            {/* Page Two */}
            {/* Page Three */}
            {/* <PageThree /> */}
            {/* Page Three */}
            {/* Page Four */}

            {/* Page Four */}
            {/* Page Five */}
            {/* <PageFour /> */}
            {/* Page Five */}
            {/* Page Six */}
            {/* <PageFive /> */}
            {/* Page Six */}
            {/* Page Seven */}
            {/* <PageSix /> */}
            {/* Page Seven */}
            {/* Page Eight */}
            {/* <PageSeven /> */}
            {/* Page Eight */}
            {/* Page Eight */}
            {/* <PageEight /> */}
            {/* Page Eight */}
            <div style={styles.fixedButton}>
                <button className="buttonPrint" onClick={() => window.print()}>
                    <img src="/assets/image/print.png" width={22} style={{ marginRight: 5 }} />
                    Print Report
                </button>
            </div>
        </div>
    );
};

export default Pemetaan;

const styles = {
    fixedButton: {
        position: "fixed",
        bottom: "20px",
        right: "0px",
        height: "auto",
        padding: "15px",
        zIndex: 99,
        // -webkit-transform: translate3d(0, 0, 0),
        transition: "all 0.25s ease",
        textAlign: "center",
    },
};
